<div class="popup" *ngIf="visible">
  <div class="image-container">
    <div class="popup-container">
      <div class="do-container">
        <div class="flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="black"
            viewBox="0 0 24 24"
          >
            <path
              d="M20.285 6.709a1 1 0 00-1.414 0L9 16.58l-4.871-4.87a1 1 0 00-1.414 1.415l5.577 5.576a1 1 0 001.414 0l10.283-10.283a1 1 0 000-1.414z"
            />
          </svg>
          <span>{{ translations['do'] }}</span>
        </div>
        <div class="flex">
          <div class="close-icon" (click)="close()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="white"
              viewBox="0 0 24 24"
            >
              <path
                d="M6 6L18 18M6 18L18 6"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="img-overlay">
        <img
          *ngFor="let img of images"
          [src]="img"
          class="img-section"
          [alt]="altText"
        />
      </div>
    </div>
  </div>
</div>
